<template>
  <div class="must">
    <ith-top-bar />

    <ith-must-watch-quiz />
    <ith-banner :item="banner" />

    <div style="" v-if="banner_top">
      <ith-sad-top :img="banner_top.imageUrl" :link="banner_top.hyperlink" />
    </div>
    <ith-submenu-must-watch />
    <ith-must-watch-recommended-lists />
    <ith-must-watch-grid />

    <div style="" v-if="banner_footer">
      <ith-sad-bottom
        :img="banner_footer.imageUrl"
        :link="banner_footer.hyperlink"
      />
    </div>
    <ith-footer />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "MustWatch",
  metaInfo: {
    title: "Must Watch Movies and TV Shows To Binge Watch - OTT Watchlist",
    meta: [
      {
        name: "description",
        content:
          "Explore the must watch tv shows and top must watch movies at OTT Watchlist. Binge Watch best web series, movies of all time.",
      },
      {
        name: "keywords",
        content:
          "must watch tv shows, must watch movies, must watch web series, must watch inspirational movies, best thriller movies",
      },
    ],
  },
  data: () => ({
    banner: {
      title: "",
      text: "",
      image: "./img/banners/MUSTWATCH_IMAGE.png",
    },
    banner_top: null,
    banner_footer: null,
  }),
  created() {
    this.$store.commit("DISABLED_MENU");
    this.$store.commit("EDIT_CRITERIA", "");
    this.getBanner();
  },

  computed: mapState(["banners"]),
  watch: {
    banners() {
      if (this.banners) this.getBanner();
    },
  },

  methods: {
    getBanner() {
      if (this.banners)
        this.banners.forEach((el) => {
          if (el.page == "mustwatch" && el.position == "top")
            this.banner_top = el;
          else if (el.page == "mustwatch" && el.position == "bottom")
            this.banner_footer = el;
        });
    },
  },
};
</script>

<style scoped>
.must {
  background-color: #2c3848;
}
</style>
